import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8272a6a4")
const _hoisted_1 = { class: "page--limited card" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-formgroup" }
const _hoisted_8 = { class: "p-field p-fluid" }
const _hoisted_9 = { class: "p-field p-fluid" }
const _hoisted_10 = { class: "p-field p-fluid" }
const _hoisted_11 = { class: "p-field p-fluid" }
const _hoisted_12 = { class: "p-field p-fluid" }
const _hoisted_13 = { class: "p-field p-fluid" }
const _hoisted_14 = { class: "p-field p-fluid" }
const _hoisted_15 = { class: "p-field p-fluid" }
const _hoisted_16 = { class: "p-d-flex" }
const _hoisted_17 = {
  id: "w3_map",
  ref: "mapEl",
  class: "p-mt-3"
}
const _hoisted_18 = { class: "uploader" }
const _hoisted_19 = {
  key: 0,
  class: "file"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image" }, null, -1)
const _hoisted_21 = { class: "file__name" }
const _hoisted_22 = { class: "uploader__open_btn" }
const _hoisted_23 = { class: "gallery" }
const _hoisted_24 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_StateAutocomplete = _resolveComponent("StateAutocomplete")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_CompanyAutocomplete = _resolveComponent("CompanyAutocomplete")!
  const _component_W3GetCoordinates = _resolveComponent("W3GetCoordinates")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: _ctx.backRoute }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-arrow-left",
              class: "p-mb-0"
            }, null, 512), [
              [
                _directive_tooltip,
                _ctx.$t('back'),
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isNew)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t('smart_zone.title_new')), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t('smart_zone.title_edit')), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-mr-1",
          onClick: _ctx.onSave
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('save'),
            void 0,
            { bottom: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-trash",
          class: "p-button-danger",
          onClick: _ctx.onDelete
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('delete'),
            void 0,
            { bottom: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('smart_zone.name')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.zone.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.zone.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('smart_zone.info')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.zone.info_zone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.zone.info_zone = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('smart_zone.contact_person')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.zone.contact_person,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.zone.contact_person = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('smart_zone.contact_phone')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.zone.contact_phone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.zone.contact_phone = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_StateAutocomplete, {
          label: "Search state",
          modelValue: _ctx.selectedState,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedState = $event)),
          onSelected: _ctx.onSelectedState
        }, null, 8, ["modelValue", "onSelected"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('smart_zone.public_notes')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.zone.note_public,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.zone.note_public = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('smart_zone.private_notes')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.zone.note_private,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.zone.note_private = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_CompanyAutocomplete, {
          modelValue: _ctx.zone.client,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.zone.client = $event)),
          type: 200,
          label: "Client",
          showDropdown: true
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_Fieldset, { legend: "W3" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_W3GetCoordinates, {
            ref: "w3El",
            modelValue: _ctx.zone.w3,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.zone.w3 = $event)),
            onResult: _ctx.onW3Result
          }, null, 8, ["modelValue", "onResult"]),
          _createVNode(_component_Button, {
            label: _ctx.$t('smart_zone.reset_shape'),
            icon: "pi pi-refresh",
            class: "p-ml-2 p-text-nowrap",
            style: {"min-width":"150px"},
            onClick: _ctx.onResetMap
          }, null, 8, ["label", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_17, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, {
      legend: _ctx.$t('smart_zone.gallery'),
      class: "p-mt-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          (_ctx.selectedFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.fileName), 1),
                (!_ctx.isNew)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-upload",
                      class: "file__action",
                      onClick: _ctx.onUpload
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadInProgress)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 1,
                class: "uploader__progress",
                mode: "indeterminate",
                style: {"height":".5em"}
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Add photo",
              onClick: _ctx.onAddPhoto
            }, null, 8, ["onClick"]),
            _createElementVNode("input", {
              type: "file",
              hidden: "",
              ref: "file_input",
              accept: "image/*",
              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFilesSelect && _ctx.onFilesSelect(...args)))
            }, null, 544)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "gallery__item",
              key: file.id
            }, [
              _createElementVNode("img", {
                src: file.file_path_url,
                height: "200"
              }, null, 8, _hoisted_24),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-times",
                class: "p-button-danger p-button-rounded gallery__delete_btn",
                onClick: ($event: any) => (_ctx.onRemoveFile(file.id))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('remove'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["legend"])
  ]))
}